import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.acceptInvitations;

const getAcceptInvitations = createSelector(
  getData,
  acceptInvitations => acceptInvitations
);

export default getAcceptInvitations;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getAcceptInvitations.js